(function () {
  const TIER_INFO = { 1: { price: 8 }, 3: { price: 15 }, 6: { price: 28 }, 9: { price: 40 }, 12: { price: 52 } };
  const PER_MINI = { 1: 8.0, 3: 5.0, 6: 4.67, 9: 4.44, 12: 4.33 };
  const BREAKPOINTS = [3, 6, 9, 12];
  const MAX = 12;
  const FREESHIP = 40;
  const box = { counts: new Map(), variant: new Map(), name: new Map(), hex: new Map() };
  let adding = false; // true while the CTA's add-then-redirect is in flight; blocks a swap's render() from re-enabling it
  const total = () => [...box.counts.values()].reduce((a, b) => a + b, 0);
  const tierFor = (n) => BREAKPOINTS.find((t) => n <= t) || MAX;

  const grid = document.getElementById("picker-grid");

  function indexTiles() {
    grid.querySelectorAll(".pick").forEach((el) => {
      const id = el.dataset.id;
      box.variant.set(id, Number(el.dataset.variantId));
      box.name.set(id, el.dataset.name);
      box.hex.set(id, el.dataset.hex);
    });
  }

  grid.addEventListener("click", (e) => {
    const tile = e.target.closest(".pick");
    if (!tile || tile.classList.contains("sold-out")) return;
    if (e.target.closest(".minus")) { e.stopPropagation(); dec(tile.dataset.id); return; }
    if (e.target.closest(".pick-link")) return; // image navigates to the product page
    inc(tile.dataset.id);
  });

  grid.addEventListener("tribe:swapped", () => { indexTiles(); render(); });
  indexTiles();

  const inc = (id) => { if (total() >= MAX) return; box.counts.set(id, (box.counts.get(id) || 0) + 1); render(); };
  const dec = (id) => { const c = box.counts.get(id) || 0; if (c <= 1) box.counts.delete(id); else box.counts.set(id, c - 1); render(); };

  function render() {
    const filled = total(), tot = tierFor(filled), atBreak = BREAKPOINTS.includes(filled), full = filled >= MAX;
    document.querySelectorAll("#tier-row .tier-pill").forEach((el) => el.classList.toggle("active", Number(el.dataset.tier) === tot));
    document.querySelectorAll(".pick").forEach((el) => {
      const c = box.counts.get(el.dataset.id) || 0;
      el.classList.toggle("selected", c > 0);
      el.classList.toggle("full-disabled", full && c === 0);
      el.querySelector(".badge").textContent = `×${c}`;
    });
    const body = document.getElementById("manifest-body");
    document.getElementById("manifest-count").textContent = `${filled} item${filled === 1 ? "" : "s"}`;
    if (filled === 0) { body.classList.add("empty"); body.innerHTML = "// no minis in the box"; }
    else {
      body.classList.remove("empty"); body.innerHTML = "";
      for (const [id, c] of box.counts.entries()) {
        const r = document.createElement("div");
        r.className = "item";
        r.innerHTML = `<span class="nm">${box.hex.get(id) ? `<span class="swatch-mini" style="background:${box.hex.get(id)};color:${box.hex.get(id)}"></span> ` : ""}${box.name.get(id)}</span>
          <span style="display:flex;align-items:center;gap:8px;"><span class="qty">×${c}</span><button class="x" data-id="${id}">[x]</button></span>`;
        r.querySelector(".x").addEventListener("click", (e) => { e.stopPropagation(); box.counts.delete(id); render(); });
        body.appendChild(r);
      }
    }
    document.getElementById("bundle-num").textContent = `${filled} / ${tot}`;
    document.getElementById("bundle-progress").style.width = `${Math.min(filled / tot, 1) * 100}%`;
    const lbl = document.getElementById("bundle-label");
    lbl.textContent = filled === 0 ? `Pick ${tot} minis` : atBreak ? "Box ready" : `${tot - filled} more to go`;
    const cta = document.getElementById("bundle-cta");
    cta.disabled = adding || !atBreak;
    cta.textContent = filled === 0 ? "Pick 3 to add to cart" : atBreak ? `// add ${filled}-mini box · $${TIER_INFO[filled].price}` : `pick ${tot - filled} more`;
    renderUpsell(tot);
  }

  function renderUpsell(tot) {
    const ub = document.getElementById("up-bundle");
    const us = document.getElementById("up-ship");
    if (!ub || !us) return;
    const ui = BREAKPOINTS.indexOf(tot);
    if (ui > -1 && ui < BREAKPOINTS.length - 1) {
      const nx = BREAKPOINTS[ui + 1], add = nx - tot, drop = (PER_MINI[tot] - PER_MINI[nx]).toFixed(2);
      ub.innerHTML = `<span class="up-ico">▲</span><span>Add <b>${add} more</b> → the <b>${nx}-pack</b> at <b>$${PER_MINI[nx].toFixed(2)}/mini</b> <span class="save">(saves $${drop} each)</span></span>`;
    } else {
      ub.innerHTML = `<span class="up-ico">✓</span><span>Lowest price unlocked — <b>$${PER_MINI[12].toFixed(2)}/mini</b>.</span>`;
    }
    if (TIER_INFO[tot].price >= FREESHIP) {
      us.innerHTML = `<span class="up-ico ship">✓</span><span><b>Ships free</b> — you’re over the $${FREESHIP} threshold.</span>`;
    } else {
      us.innerHTML = `<span class="up-ico ship">+</span><span><b>$${FREESHIP - TIER_INFO[tot].price}</b> from <b>free shipping</b> ($${FREESHIP}+) — the <b>9-pack</b> ships free.</span>`;
    }
  }

  document.getElementById("picker-reset").addEventListener("click", () => { box.counts.clear(); render(); });
  document.getElementById("bundle-cta").addEventListener("click", async (e) => {
    const cta = e.currentTarget;
    const n = total();
    if (!BREAKPOINTS.includes(n)) return;
    adding = true; cta.disabled = true; cta.textContent = "// adding…";
    document.getElementById("bundle-err").hidden = true;
    const items = [...box.counts.entries()].map(([id, q]) => ({ id: box.variant.get(id), quantity: q }));
    try {
      await MiniCart.addItems(items);
      box.counts.clear();
      window.location.href = "/cart";
    } catch (err) {
      adding = false;
      const msg = document.getElementById("bundle-err");
      msg.textContent = err.message;
      msg.hidden = false;
      render();
    }
  });

  const section = grid.closest(".builder");
  if (section && "IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => section.classList.toggle("in-view", entry.isIntersecting), { threshold: 0 }).observe(section);
  }
  render();
})();

// Quicklook: tapping a tile's image opens the dialog instead of navigating.
// Delegated on document so it survives tribe-filter/pager fragment swaps;
// without JS the image link still goes straight to the product page.
(function () {
  const dlg = document.getElementById("quicklook");
  if (!dlg || typeof dlg.showModal !== "function") return;
  const img = document.getElementById("ql-img");
  const name = document.getElementById("ql-name");
  const price = document.getElementById("ql-price");
  const add = document.getElementById("ql-add");
  const link = document.getElementById("ql-link");
  let srcPick = null;

  document.addEventListener("click", (e) => {
    const a = e.target.closest("#picker-grid .pick-link");
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    srcPick = a.closest(".pick");
    img.src = srcPick.dataset.imgLarge || "";
    img.alt = srcPick.dataset.name || "";
    name.textContent = srcPick.dataset.name || "";
    price.textContent = srcPick.dataset.price || "";
    link.href = a.href;
    add.hidden = srcPick.classList.contains("sold-out");
    dlg.showModal();
  }, true); // capture: beat the grid's whole-tile inc() handler

  dlg.querySelector(".ql-close").addEventListener("click", () => dlg.close());
  dlg.addEventListener("click", (e) => { if (e.target === dlg) dlg.close(); });
  add.addEventListener("click", () => {
    const plus = srcPick && srcPick.querySelector(".plus");
    if (plus) plus.click();
    dlg.close();
  });
})();
